import { css } from 'twin.macro';
import React, { useState, Fragment, useEffect } from 'react';
import { Tabs, Tab } from 'react-bootstrap';

// icons
import { VscLoading } from 'react-icons/vsc';

//helpers
import { fetchWrapper, Permission, getUniqueObjects } from '../../../_helpers';
import InfiniteScroll from 'react-infinite-scroller';
import SubmissionModal from '../UserFormData/SubmissionModal';
import ManagerFormView from '../Teams/ManagerFormView';
import ShareForm from '../PublicForms/ShareForm';

function ChatInputFormModal({ currRoom, team, userId, position, channelRole, handleFormClosed, handleFormOpened }) {
    const [template, setTemplate] = useState([]);
    const [hasMore, setHasMore] = useState(true);
    const [totalPages, setTotalPages] = useState(1000000);
    const [loadingForms, setLoadingForms] = useState(false);
    const [tabKey, setTabKey] = useState('forms');

    useEffect(() => {
        loadFunc();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const loadFunc = async (page = 1) => {
        if (currRoom) {
            if (page <= totalPages) {
                try {
                    setLoadingForms(true);
                    const formTemplates = await fetchWrapper.get(
                        `forms/?chatroom=${currRoom.id || currRoom._id}&limit=50&page=${page}&autoFillField=true`
                    );
                    let tempTemplate = getUniqueObjects([...template], [...formTemplates.results]);
                    setTemplate(tempTemplate);
                    setHasMore(formTemplates.totalResults > tempTemplate.length);
                    setTotalPages(formTemplates.totalPages);
                } catch (err) {
                    console.log(err);
                    setHasMore(false);
                } finally {
                    setLoadingForms(false);
                }
            }
        }
    };

    return (
        <div className="option-members-content">
            <Tabs id="controlled-tab-example" activeKey={tabKey} onSelect={(k) => setTabKey(k)}>
                <Tab eventKey="forms" title="Forms">
                    <div
                        css={css`
                            height: 400px;
                            overflow: auto;
                            padding: 1rem 0;
                        `}
                    >
                        <InfiniteScroll
                            pageStart={1}
                            loadMore={loadFunc}
                            hasMore={hasMore && !loadingForms}
                            useWindow={false}
                        >
                            {hasMore || (template && template.length > 0) ? (
                                template
                                    .sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1))
                                    .map((tem, idx) => (
                                        <div className="d-flex" key={tem.createdAt + idx}>
                                            <SubmissionModal
                                                form={tem}
                                                roomId={currRoom && (currRoom.id || currRoom._id)}
                                                userId={userId}
                                                currRoom={currRoom}
                                                formType={tem.type}
                                                position={position}
                                                team={team}
                                                handleFormClosed={handleFormClosed}
                                                handleFormOpened={handleFormOpened}
                                            />
                                            <ShareForm
                                                form={tem}
                                                roomId={currRoom && (currRoom.id || currRoom._id)}
                                                userId={userId}
                                                currRoom={currRoom}
                                                formType={tem.type}
                                                position={position}
                                                team={team}
                                                handleFormClosed={handleFormClosed}
                                                handleFormOpened={handleFormOpened}
                                            />
                                            <Permission
                                                role={channelRole}
                                                perform="view:form"
                                                yes={() => (
                                                    <Fragment>
                                                        <ManagerFormView
                                                            roomId={currRoom && (currRoom.id || currRoom._id)}
                                                            form={tem}
                                                            handleFormClosed={handleFormClosed}
                                                            handleFormOpened={handleFormOpened}
                                                        />
                                                    </Fragment>
                                                )}
                                                no={() => null}
                                            />
                                        </div>
                                    ))
                            ) : (
                                <div className="p-4 d-flex justify-content-center align-items-center">No Forms</div>
                            )}
                        </InfiniteScroll>
                        {!loadingForms ? null : (
                            <div
                                className="loader"
                                key={0}
                                css={css`
                                    height: 100%;
                                    min-height: 100px;
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                `}
                            >
                                <VscLoading fontSize={34} className="spin" />
                            </div>
                        )}
                    </div>
                </Tab>
            </Tabs>
        </div>
    );
}

export default ChatInputFormModal;
